<template>
    <div class="disclaimer-wrap opt-in" v-show="!isLogin || isShowTcpaConsent">
        <div class="tcpa-consent" v-if="!isLogin || isShowTcpaConsent">
            <div class="disclaimer-item consent-item noTop" :class="{'noParty': !hasParties}">
                <Checkbox
                    :color="color"
                    :fontColor="color"
                    :checked="checkResult.checkedDefault"
                    @change="onCheckTcpaDefault"
                />
                <div
                    v-html="consentOption.text"
                    class="disclaimer-content party-consent"
                    :style="disclaimerContentStyle"
                ></div>
            </div>
        </div>
        <div class="custom-disclaimer-list" :class="{ 'gap-line': !!customDisclaimerList.length }" v-if="!isLogin">
            <div
                v-for="(item, i) in customDisclaimerList"
                class="disclaimer-item"
                :key="item.id"
                :class="{'noTop' : i === 0}"
            >
                <Checkbox
                    :color="color"
                    :fontColor="color"
                    :checked="checkResult.custom[i]"
                    @change="_ => onCheckTcpa('custom', i)"
                />
                <div
                    v-html="item.text"
                    class="disclaimer-content"
                    :style="disclaimerContentStyle"
                ></div>
            </div>
        </div>
    </div>
</template>
<script>
// 1.初始化 触发change => 是否全选 => 禁用
// 2.切换 触发change => 是否全选 => 禁用
import { mapState, mapActions } from 'pinia';
import { usePageStore, useUserStore } from '@/store';
import Checkbox from '@/components/checkbox.vue';
import { INTERCEPT_URL } from '@/common/customize';
import { defaultLngCode } from '@/globalization/constant.js';
const ownerShipName = 'ownership target name'
const ownerPhoneNumber  = 'site owner phone number'

export default {
    i18next: {
        ns: 'common'
    },
    emits: ['updateChecked', 'disclaimerContainerMount'],
    props: {
        noShowCustomDisclaimer: {
            type: Boolean,
            default: false
        },
        color: {
            type: String,
            default: ''
        },
        disclaimerUniqId: {
            type: String,
            required: true
        },
        privacyText: {
            type: String,
            default: ''
        },
        isShowTcpaConsent: { // after login it maybe display Tcpa Consent
            type: Boolean,
            default: false
        },
        fromTcpa: {
            type: Boolean,
            default: false
        },
        btnText: {
            type: String,
            default: ''
        }
    },
    data: function() {
        return {
            disclaimerAgreements: [],
            loading: true,
            checkResult: {
                noParties: true,
                parties: true,
                custom: [],
                checkedDefault: false
            },
            consentOption: {},
            customDisclaimerList: [],
            agentPhoneNumber: '',
            isLoadingPhone: true,
        };
    },
    computed: {
        ...mapState(useUserStore, {
            user: store => store.user
        }),
        ...mapState(usePageStore, {
            globalData: store => store.page || {},
            newDisclaimersMap: store => store.page.newDisclaimersMap || {},
            adsDisclaimersMap: store => store.page.adsDisclaimersMap || {},
            defaultCompanyName: store => store.defaultCompanyName,
            hasLender: store => store.hasLender,
            agents: store => store.agents,
            lenderInfo: store => store.lenderInfo,
            agentCreator: store => store.page?.agentCreator || {},
            // currentLanguage: store => store.currentLanguage,
        }),
        siteDisclaimerMap() {
            if (this.isCoMarketing) {
                return this.adsDisclaimersMap.siteDisclaimerMap || {}
            } else {
                return this.newDisclaimersMap.siteDisclaimerMap || {}
            }
        },
        isLogin() {
            return !!this.user;
        },
        hasParties({ consentOption }) {
            return !!consentOption.parties?.length
        },
        isCoMarketing() {
            if (this.fromTcpa) {
                return false;
            } else {
                return !!this.lenderInfo
            }
        },
        disclaimerContentStyle({ color }) {
            return color ? { '--g-text-color': color } : {};
        },
        privacyHtml({ defaultCompanyName }) {
            return this.$t('common:register.PRIVACY_HTML', {
                companyName: defaultCompanyName
            });
        }
    },
    watch: {
        isLogin() {
            this.init();
            this.calcContainerHeight();
        },
        disclaimerUniqId() {
            this.calcContainerHeight();
        },
        siteDisclaimerMap: {
            handler() {
                this.consentOption = this.getConsentOption();
                this.customDisclaimerList = this.getCustomDisclaimerList();
                this.resetCheckResult();
            },
            immediate: true,
            deep: true,
        },
        agentPhoneNumber: {
            handler(val) {
                if (val) {
                    this.consentOption = this.getConsentOption();
                }
            },
            immediate: true,
        },
        isLoadingPhone: {
            handler(val) {
                if (!val) {
                    this.consentOption = this.getConsentOption();
                }
            },
            immediate: true,
        },
        btnText: {
            handler(val) {
                if (val) {
                    this.consentOption = this.getConsentOption();
                }
            },
            immediate: true,
        }
    },
    async created() {
        await this.getSupportPhone();
        this.$emit('updateChecked', false); // 初始化开始设置为禁用，数据加载完成后还原为真实状态
    },
    async mounted() {
        let ps = [];
        ps.push(this.getCompanyInfo());
        ps.push(this.fetchHasLender());
        ps.push(this.fetchLenderInfo());
        Promise.all(ps)
            .catch(err => {
                console.error(err);
            })
            .finally(_ => {
                this.loading = false;
                this.init();
            });
        // for md-form layout5
        this.calcContainerHeight();
    },
    methods: {
        ...mapActions(usePageStore, [
            'getPermissionFromAdmin',
            'setCustomParams',
            'setCurrentUniqId',
            'getCompanyInfo',
            'fetchHasLender',
            'fetchLenderInfo'
        ]),
        getSupportPhone() {
            this.axiosIns.post('/api-graphql', {
                query: '{agent(id: 0){fullName,supportNumber}}'
            }).then(res => {
                this.agentPhoneNumber = res.data?.agent?.supportNumber || ''
                this.updateCheckedTcpa();
            }).finally(() => {
                this.isLoadingPhone = false
            })
        },
        init() {
            this.setDisclaimerAgreements();
            this.resetCheckResult();
            this.updateCheckedTcpa();
        },
        getConsentOption() {
            const { tcpaConsent } = this.siteDisclaimerMap || {}
            const { parties = [], registrationRequired, customText = {} } = tcpaConsent || {}
            const defaultText = parties?.length > 0 ? customText.hasPartyDefaultLanguage : customText.noPartyDefaultLanguage
            let replaceDefaultText = this.replaceDefaultText(defaultText || '') || ''
            return {
                registrationRequired,
                text: this.replaceVarForConsent(replaceDefaultText),
                parties: this.isCoMarketing ? this.replacePartiesForCoMarketing(parties) : parties
            }
        },
        replacePartiesForCoMarketing(parties) {
            return parties.map(item => {
                return {
                    id: item.id,
                    text: this.replaceDefaultText(item.text || '')
                }
            })
        },
        getCustomDisclaimerList() {
            const { customDisclaimers = [] } = this.siteDisclaimerMap || {}
            return customDisclaimers.map(item => {
                return {
                    id: item.id,
                    registrationRequired: item.registrationRequired,
                    text: item.language2TextMap?.[defaultLngCode],
                }
            })
        },
        calcContainerHeight() {
            this.$nextTick(() => {
                this.$emit('disclaimerContainerMount', this.isLogin ? 0 : this.$el.clientHeight);
            })
        },
        getAgentLenderInfo() { // co-marketing, agent and lender
            const { parties } = this.checkResult
            const info = {
                textOptIn: parties,
                callOptIn: parties,
                lenderTextOptIn: parties,
                lenderCallOptIn: parties,
            }
            if (this.lenderInfo?.lenderUserId) {
                info.lenderId = this.lenderInfo.lenderUserId
            }
            return info
        },
        resetCheckResult() {
            const { customDisclaimers } = this.siteDisclaimerMap
            const customDisclaimersLen = customDisclaimers?.length
            this.checkResult = {
                noParties: true,
                parties: true,
                custom: new Array(customDisclaimersLen).fill(false),
                checkedDefault: false
            }
        },
        getPlainTextFromHTML(htmlString) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = htmlString;
            return tempDiv.textContent || tempDiv.innerText || "";
        },
        replaceDefaultText(defaultText) {
            const infoMap = this.isCoMarketing ? this.adsDisclaimersMap : this.newDisclaimersMap
            // Use temporary variables for parties processing to avoid modifying original data
            let parties = '';
            const partiesData = this.siteDisclaimerMap?.tcpaConsent?.parties;
            if (partiesData && partiesData.length > 0) {
                // Create a copy of the temporary array
                const tempParties = partiesData.map(item => ({ ...item }));
                
                // If there are multiple parties, connect the last two with internationalized "and"
                if (tempParties.length > 1) {
                    const lastParty = tempParties.pop();
                    lastParty.text = this.$t('common:partiesConnector', { text: lastParty.text })
                    tempParties.push(lastParty);
                }
                parties = tempParties.map(item => item.text).join(', ');
            }
            const { params } = infoMap || {}
            let phoneNumber = !this.isLoadingPhone ? this.formatPhone(this.agentPhoneNumber || params?.[ownerPhoneNumber] || '') : '';
            const data = {
                phone_number: phoneNumber,
                lender_full_name: this.lenderInfo?.fullName,
                agent_full_name: params?.[ownerShipName] || '',
                button_text: this.getPlainTextFromHTML(this.btnText) || 'SUBMIT',
                seller_variable: params?.[ownerShipName] || '',
                parties: parties,
            }
            const reg = /#(\w+)#/;
            if (reg.test(defaultText)) {
                const name = reg.exec(defaultText)[1] 
                defaultText = defaultText.replace(reg, data[name] || '')
                return this.replaceDefaultText(defaultText)
            }
            return defaultText
        },
        replaceVarForConsent(text) {
            const infoMap = this.isCoMarketing ? this.adsDisclaimersMap : this.newDisclaimersMap
            const { params } = infoMap || {}
            const reg = /<span class="variable" contenteditable="false">#([^#]+)#<\/span>/;
            if (reg.test(text)) {
                const name = reg.exec(text)[1] 
                text = text.replace(reg, params?.[name] || '')
                return this.replaceVarForConsent(text)
            }
            return text
        },
        getVarForConsent(text) {
            const infoMap = this.isCoMarketing ? this.adsDisclaimersMap : this.newDisclaimersMap
            const { params } = infoMap || {}
            const insertedVars = this.extractHashtags(text);
            let variables = {}
            insertedVars.forEach(item => {
                variables[item] = params?.[item] || ''
            })
            return variables
        },
        extractHashtags(text) {
            const reg = /<span class="variable" contenteditable="false">#([^#]+)#<\/span>/g;
            let match;
            const hashtags = [];
            while ((match = reg.exec(text))) {
                hashtags.push(match[1]);
            }
            return hashtags;
        },
        onCheckTcpaDefault() {
            this.checkResult.checkedDefault = !this.checkResult.checkedDefault
            this.updateCheckedTcpa();
        },
        onCheckTcpa(type, index) {
            this.checkResult[type][index] = !this.checkResult[type][index]
            this.updateCheckedTcpa();
        },
        formatPhone(phoneNumber) {
            return phoneNumber.replace(/^(\d{3})-?(\d{3})-?(\d{4})$/, '$1-$2-$3')
        },
        updateCheckedTcpa() {
            let value = this.getCheckAllTcpa()
            const agreementInfo = this.getTcpaAgreementInfo()
            const otherInfo = this.isCoMarketing ? this.getAgentLenderInfo() : {}
            const axiosUrl = !this.isLogin ? INTERCEPT_URL.leadRegister : INTERCEPT_URL.updatePhone
            this.setCurrentUniqId(
                axiosUrl,
                this.disclaimerUniqId
            );
            this.setCustomParams(
                axiosUrl,
                this.disclaimerUniqId,
                { 
                    agreementInfo,
                    ...otherInfo
                }
            );
           
            this.$emit('updateChecked', value, {
                agreementInfo
            });
        },
        /**
         * tcpaIgnoreCheck is a trick key
         * when tcpaIgnoreCheck.default is true, it means we ignore the default disclaimer
         * when tcpaIgnoreCheck.custom is true, it means we ignore the custom disclaimer
         * this key will be added into the custom script section in the setting depend on the domain that its owner want this behavior
         * how to add it: set this code into the custom script: getStore('page').page.tcpaIgnoreCheck = { default: true, custom: true }
         */
        getCheckAllTcpa() {
            let globalData = this.globalData || {};
            if (globalData.ignoreRegisterCheck) {
                // 留一个不校验的后门，通过刷数据
                return true;
            }

            let tcpaIgnoreCheck = globalData.tcpaIgnoreCheck || {};
            let defaultChecked = this.checkResult.checkedDefault;
            // let customChecked = this.checkCustomDisclaimers();
            
            if (tcpaIgnoreCheck.default) {
                defaultChecked = true;
            }
            // may be need to check the custom disclaimer
            // if (tcpaIgnoreCheck.custom) {
            //     customChecked = true;
            // }
            if (this.isLogin) {
                if (this.isShowTcpaConsent) {
                    return defaultChecked
                }
                return true
            } 
            return defaultChecked && this.checkCustomDisclaimers();
        },
        checkCustomDisclaimers() {
            let isValid = true
            const { customDisclaimers } = this.siteDisclaimerMap
            const len = customDisclaimers?.length
            for (let i = 0; i < len; i++) {
                let curItem = customDisclaimers[i];
                if (curItem.registrationRequired && !this.checkResult.custom[i]) {
                    isValid = false;
                    break;
                }
            }
            return isValid
        },
        getAgreementInfoParties() {
            const { tcpaConsent } = this.siteDisclaimerMap;
            let parties = tcpaConsent?.parties
            if (this.isCoMarketing) {
                parties = this.replacePartiesForCoMarketing(parties);
            }
            return parties?.map?.(item => item.text).join(', ');
        },
        getTcpaAgreementInfo() {
            const { websiteInfo } = this.globalData
            const infoMap = this.isCoMarketing ? this.adsDisclaimersMap : this.newDisclaimersMap
            const { privacyPolicyVersionId, tosVersionId, customDisclaimerVersionId, params, siteDisclaimerType } = infoMap || {}
            const { customDisclaimers, tcpaConsent } = this.siteDisclaimerMap
            let phoneNumber = this.formatPhone(this.agentPhoneNumber || params?.[ownerPhoneNumber] || '');
            const defaultVars = {
                'phone_number': phoneNumber,
                'button_text': this.btnText || 'SUBMIT',
                'seller_variable': params?.[ownerShipName] || '',
                'parties': this.getAgreementInfoParties(),
            }
            if (this.isCoMarketing) {
                defaultVars['agent_full_name'] = params?.[ownerShipName] || ''
                defaultVars['lender_full_name'] = this.lenderInfo?.fullName
            }
            const agreementInfo = {
                // version of tos url
                termsOfServiceUrl: `https://${websiteInfo?.domainName}/site/privacy-terms?dataHash=${tosVersionId}&type=0#terms-of-service`,
                // version of policy url
                privacyPolicyUrl: `https://${websiteInfo?.domainName}/site/privacy-terms?dataHash=${privacyPolicyVersionId}&type=1#privacy-policy`,
                // variables in Consent
                variables: {},
                // selected parties 
                selectedParties: [],
                useCustomConsent: !!tcpaConsent?.useCustomConsent,
                type: siteDisclaimerType || 4 // default value: 4
            }
            if (!this.isLogin) { // disclaimer
                agreementInfo.versionId = customDisclaimerVersionId,
                agreementInfo.selectedDisclaimers = this.checkResult.custom.map((item, index) => {
                    if (item) {
                        return customDisclaimers[index].id
                    } else {
                        return ''
                    }
                }).filter(Boolean)
            }
            const { customText = {}, parties } = tcpaConsent || {}
            agreementInfo.noPartiesAgree = this.checkResult.noParties
            agreementInfo.selectedParties = []
            const curText = parties?.length > 0 ? customText.hasPartyDefaultLanguage : customText.noPartyDefaultLanguage
            const consentVars = this.getVarForConsent(curText)
            agreementInfo.variables = {
                ...consentVars,
                ...defaultVars,
            }
            return agreementInfo
        },
        onCheck(index) {
            this.disclaimerAgreements[index] =
                !this.disclaimerAgreements[index];
            this.updateChecked();
        },
        updateChecked() {
            let value =
            this.pageLocation.query.optInAudit == 1
                ? false
                : this.getCheckAll();
            if (this.globalData?.ignoreRegisterCheck) {
                // 留一个不校验的后门，通过刷数据
                value = true;
            }
            this.$emit('updateChecked', value);
        },
        getCheckAll() {
            // custom disclaimer options
            if (this.isLogin || this.noShowCustomDisclaimer) {
                return true;
            }
            // 全选
            return this.disclaimerAgreements.every(item => item);
        },
        setDisclaimerAgreements() {
            this.disclaimerAgreements = [false];
        },
    },
    components: {
        Checkbox
    }
};
</script>
<style lang="scss">
@import '../theme/mixin.scss';
.disclaimer-wrap.opt-in {
    position: static;
    color: var(--color-label);
    font-size: 12px;
    line-height: 1.5;
    text-align: left;
    height: auto;
    overflow-y: auto;
    margin-top: 20px !important;
    a {
        color: var(--color-link, var(--color-theme, #03c9ff));
        text-decoration: underline;
    }
    .tcpa-consent {
        .consent-item {
            display: flex;
        }
    }

    .checkbox-li {
        height: 18px;
        line-height: 18px;
        .check-box-container {
            width: 14px;
            height: 14px;
            margin-top: 2px;
            position: relative;
            &::after {
                content: '';
                width: 24px;
                height: 24px;
                position: absolute;
                top: -5px;
                left: -5px;
                cursor: pointer;
            }
        }
    }
    .disclaimer-item {
        display: flex;
        overflow: hidden;
        margin-top: 10px;
        &.noTop {
            margin-top: 0 !important;
        }
    }
    .gap-line {
        margin-top: 15px;
        border-top: 1px solid var(--color-border);
        padding-top: 15px;
    }
    .communication-tips {
        margin-top: 10px;
    }
    .privacy-text {
        overflow: hidden;
        color: var(--g-text-color);
        &::before {
            content: '';
            display: block;
            width: 100%;
            height: 1px;
            margin: 20px 0;
            background: var(--color-border);
        }
        a {
            color: var(--color-link, var(--color-theme, #03c9ff));
            text-decoration: underline;
        }
    }
    .disclaimer-content {
        width: 100%;
        word-break: break-word;
        text-align: left;
        color: var(--g-text-color);
        a {
            color: var(--color-link, var(--color-theme, #03c9ff)) !important;
            text-decoration: underline;
        }
        .select-all {
            color: var(--color-link, var(--color-theme, #03c9ff));
            text-decoration: underline;
            cursor: pointer;
        }
    }
    @include adapter((margin-top, 20px, 30px));
    .co-marketing-disclaimer {
        .disclaimer-desc {
            margin-top: 20px;
            border-top: 2px solid #545454;
            padding-top: 20px;
        }
    }
}
</style>
